import { useLingui } from '@lingui/react/macro'
import { Field, FieldLabel } from 'designSystem/components/Field'
import {
  ToggleGroup,
  ToggleGroupItem,
} from 'designSystem/components/ToggleGroup'
import {
  type BugReportType,
  bugReportTypeSchema,
} from 'features/knowledgeDocumentViewer/utils/viewerBugReport'
import { useCallback } from 'react'

type BugReportTypeFieldProps = {
  value: BugReportType
  disabled?: boolean
  onChange: (type: BugReportType) => void
}

export function BugReportTypeField({
  value,
  disabled = false,
  onChange,
}: BugReportTypeFieldProps) {
  const { t } = useLingui()
  const handleChange = useCallback(
    (nextValue: string) => {
      const parsed = bugReportTypeSchema.safeParse(nextValue)
      if (parsed.success) {
        onChange(parsed.data)
      }
    },
    [onChange]
  )

  return (
    <Field>
      <FieldLabel htmlFor='bug-report-type'>{t`Type`}</FieldLabel>
      <ToggleGroup
        id='bug-report-type'
        type='single'
        variant='outline'
        size='lg'
        value={value}
        disabled={disabled}
        onValueChange={handleChange}>
        <ToggleGroupItem value='bug'>{t`Bug`}</ToggleGroupItem>
        <ToggleGroupItem value='feature'>{t`Feature`}</ToggleGroupItem>
        <ToggleGroupItem value='improvement'>{t`Improvement`}</ToggleGroupItem>
      </ToggleGroup>
    </Field>
  )
}
